import { translate } from '@teamleader/i18n';
import { DateTime } from 'luxon';
import React, { useContext } from 'react';

import Banner from '../../../Components/UI/Banner';
import Box from '../../../Components/UI/Box';
import { isAfter } from '../../../Utils/date';
import { MODES, UrlContext } from '../../../Utils/jwt';
import useGlobalContext from '../Context';

const Banners: React.FC = () => {
  const { mode, expiresAt } = useContext(UrlContext);
  const { banners } = useGlobalContext();

  return (
    <Box>
      {mode === MODES.PREVIEW && <Banner label={translate('preview.banner')} />}

      {isAfter(DateTime.local().startOf('day'), expiresAt) && (
        <Banner label={translate('expired.banner')} variant="warning" />
      )}
      {banners && banners.map((bannerProps, index) => <Banner key={index} {...bannerProps} />)}
    </Box>
  );
};

export default Banners;
